export const NOTIFICATIONS_CHANNEL_OPTIONS = {
  slack: 'slack',
  email: 'email',
  whatsapp: 'whatsapp',
};
